export default {"src":"/_next/static/media/homepage-red-icon.5b5cb258.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};